"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var html_to_react_1 = require("html-to-react");
var Link_1 = require("./../../components/atoms/Link");
// IDP components.
var state_manager_1 = require("@idp/state-manager");
var Loading_1 = require("./../../components/atoms/Loading");
var ButtonProps_1 = require("./../../components/atoms/Button/ButtonProps");
var ModalProps_1 = require("./../../components/atoms/Modal/ModalProps");
// Services.
var Networker = require("./../Networker");
// Constants.
// import { APP_NAMESPACE } from './../../constants/AppConstants';
// Styles.
var LegalStyles = require("./../../components/atoms/Legal/Legal.css");
var LegalProvider = /** @class */ (function () {
    function LegalProvider() {
        var _this = this;
        this.analyticsValues = {};
        this.getLegal = function (legalPath, analytics, callback, defaults) { return __awaiter(_this, void 0, void 0, function () {
            var url_1;
            var _this = this;
            return __generator(this, function (_a) {
                this.analyticsValues = analytics || {};
                if (legalPath) {
                    url_1 = this.formatLegalUrl(legalPath);
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var customHeaders = new Headers();
                            customHeaders.append('Access-Control-Allow-Origin', '*');
                            Networker.networker.get(url_1, { headers: customHeaders })
                                .then(function (response) {
                                return Networker.parseJSON(response);
                            })
                                .then(function (data) {
                                resolve(_this.getStaticLegal(data, callback));
                            })
                                .catch(function (error) {
                                if (defaults && defaults !== {}) {
                                    resolve(_this.getStaticLegal(defaults, callback));
                                }
                                else {
                                    reject({ error: error });
                                }
                            });
                        })];
                }
                else if (defaults && defaults !== {}) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            resolve(_this.getStaticLegal(defaults, callback));
                        })];
                }
                return [2 /*return*/];
            });
        }); };
        this.formatLegalUrl = function (url, html) {
            var newUrl = url;
            if (newUrl) {
                var newExt = html ? "html" : "json";
                // Check if it is NOT an absolute path.
                var protocolRegEx = new RegExp("^(?:[a-z]+:)?//", "i");
                if (!protocolRegEx.test(newUrl)) {
                    // Check if the path begins with "/content/".
                    var contentRegEx = new RegExp("^/content/");
                    if (contentRegEx.test(newUrl)) {
                        // Replace "/content/" with "/ecms/".
                        newUrl = newUrl.replace(contentRegEx, "/ecms/");
                    }
                }
                // Get the extension.
                var ext = /(?:\.([^.]+))?$/.exec(newUrl)[1];
                if (ext) {
                    // Ensure the extension is "json" or "html".
                    newUrl = newUrl.replace(new RegExp(ext + "$", "i"), newExt);
                }
                else {
                    newUrl += "." + newExt;
                }
            }
            return newUrl;
        };
        this.getStaticLegal = function (values, callback) {
            var processedResponse = _this.processAjaxResponse(values);
            if (callback) {
                callback(processedResponse);
            }
            return processedResponse;
        };
        this.htmlToReact = function (content) {
            var processNodeDefinitions = new html_to_react_1.ProcessNodeDefinitions(React);
            var processingInstructions = [
                {
                    processNode: function (node, children, index) {
                        var attributes = node.attribs || {};
                        var cta = (node.children && node.children[0] && node.children[0].data) ?
                            node.children[0].data
                            : undefined;
                        return React.createElement(Link_1.default, {
                            data: {
                                content: cta,
                            },
                            events: {
                                onClick: function (event) {
                                    if (attributes.onClick) {
                                        attributes.onClick(event);
                                    }
                                },
                                onFocus: function (event) {
                                    if (attributes.onFocus) {
                                        attributes.onFocus(event);
                                    }
                                },
                            },
                            options: {
                                accessibility: attributes["aria-label"] || attributes.title || cta,
                                analytics: {
                                    contentFriendlyName: _this.analyticsValues.contentFriendlyName || cta,
                                    contentId: _this.analyticsValues.contentId,
                                    contentProductGroup: _this.analyticsValues.contentProductGroup,
                                    linkDestinationUrl: attributes.href,
                                    linkName: cta,
                                    linkPath: "",
                                    linkPosition: _this.analyticsValues.linkPosition || "Body",
                                    slotFriendlyName: _this.analyticsValues.slotFriendlyName,
                                    slotPosition: _this.analyticsValues.slotPosition,
                                },
                                className: attributes.class + " " + LegalStyles.anchorClass,
                            },
                            title: attributes.title,
                        });
                    },
                    shouldProcessNode: function (node) {
                        return node.name === "a";
                    },
                },
                {
                    processNode: processNodeDefinitions.processDefaultNode,
                    shouldProcessNode: function (node) { return true; },
                },
            ];
            var htmlToReactParser = new html_to_react_1.Parser();
            return htmlToReactParser.parseWithInstructions(content, _this.isValidNode, processingInstructions);
        };
        this.isValidNode = function () { return true; };
        this.parseJsonResponse = function (response) {
            var returnResponse = {
                action: response.action,
                contentLong: response.longtext,
                contentShort: response.shorttext,
                lineBreak: response.lineBreak,
                modalSize: response.modalSize,
                modalTitle: response.modaltitle,
                offerKey: response.offerkey,
                offerName: response.offername,
                shortDescLinkText: response.shortdesclinktext,
                targetWindow: response.targetWindow,
            };
            return returnResponse;
        };
        this.processAjaxResponse = function (response) {
            var legalContent = _this.parseJsonResponse(response);
            legalContent.contentLong = _this.parseContent(legalContent.contentLong, legalContent.lineBreak);
            legalContent.contentShort = _this.parseContent(legalContent.contentShort, legalContent.lineBreak);
            legalContent.modalSize = (function () {
                var size = ModalProps_1.ModalSizes.MEDIUM;
                switch (legalContent.modalSize) {
                    case "modal505":
                        size = ModalProps_1.ModalSizes.MEDIUM;
                        break;
                    case "modal705":
                        size = ModalProps_1.ModalSizes.LARGE;
                        break;
                }
                return size;
            })();
            legalContent.shortDescLinkText = _this.parseLink(legalContent);
            return legalContent;
        };
        this.parseContent = function (content, lineBreak) {
            if (content) {
                if (content !== "&nbsp;" && content !== " ") {
                    var tag = lineBreak ? "div" : "span";
                    var space = lineBreak ? "" : " ";
                    return _this.htmlToReact("<" + tag + ">" + content + space + "</" + tag + ">");
                }
                return "%{NULL}";
            }
            return undefined;
        };
        this.parseLink = function (legalContent) {
            if (legalContent.shortDescLinkText) {
                var className = legalContent.lineBreak ? "cta-legal-block" : "cta-legal";
                var content = legalContent.shortDescLinkText;
                var href = _this.formatLegalUrl(legalContent.action, true);
                return React.createElement(Link_1.default, {
                    data: {
                        content: content,
                    },
                    events: {
                        onClick: function (event) {
                            var stateManager = state_manager_1.StateProvider.getStateManagerInstance('appShell');
                            event.preventDefault();
                            window.AttModalContent = React.createElement(Loading_1.default);
                            stateManager.set('modal', {
                                content: legalContent.action,
                                modalSize: ModalProps_1.ModalSizes.SMALL,
                            });
                            // setTimeout(()=>{ // for testing network delays
                            // this.getLegal(legalContent.action, this.analyticsValues, (legalValues: LegalResponse) => {
                            //     // Set modal values to the AppState so the modal will open on click.
                            //     const modalState = stateManager.get(APP_NAMESPACE, 'modal') as { content: string };
                            //     if (window.AttModalContent && modalState.content === legalContent.action) {
                            //         window.AttModalContent = legalValues.contentLong || legalValues.contentShort;
                            //         stateManager.set('modal', {
                            //             ...legalValues, ...{
                            //                 content: legalContent.action,
                            //             },
                            //         });
                            //     }
                            // });
                            // },5000);
                        },
                    },
                    options: {
                        accessibility: legalContent.accessibility || "Click here to see more legal",
                        analytics: {
                            contentFriendlyName: _this.analyticsValues.contentFriendlyName || content,
                            contentId: _this.analyticsValues.contentId,
                            contentProductGroup: _this.analyticsValues.contentProductGroup,
                            linkDestinationUrl: _this.analyticsValues.linkDestinationUrl || href,
                            linkName: _this.analyticsValues.linkName || content,
                            linkPath: "",
                            linkPosition: _this.analyticsValues.linkPosition || "Body",
                            slotFriendlyName: _this.analyticsValues.slotFriendlyName,
                            slotPosition: _this.analyticsValues.slotPosition,
                        },
                        className: className,
                        type: ButtonProps_1.ButtonType.TEXT,
                    },
                });
            }
            return "";
        };
    }
    return LegalProvider;
}());
exports.default = LegalProvider;
//# sourceMappingURL=LegalProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/services/LegalProvider/LegalProvider.js
// module id = 1177
// module chunks = 8